import React from "react";
import Icons from "../common/components/Icons";

const SearchBlogs = () => {
  return (
    <label
      htmlFor="@filter-blogs"
      className="w-full py-3 md:py-[15px] px-5 md:px-7 flex items-center gap-x-1.5 bg-white rounded-[50px]">
      <Icons icon="search" />
      <input
        className="leading-155 font-normal text-custom-black placeholder:text-opacity-80 w-full border-0 outline-none"
        type="text"
        name=""
        id="filter-blogs"
        placeholder="Type of search..."
      />
    </label>
  );
};

export default SearchBlogs;
